import React from "react";
import t from "babel-plugin-yate/macro";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Link } from "react-router-dom";
import { Form, Field } from "react-final-form";
import get from "lodash-es/get";

import { logIn } from "../store/auth";
import { isRequired } from "../lib/validations";
import logo from "../assets/credex-logo-1.svg";
import Button from "../components/Button";
import { Input } from "../components/Form/Input";

const Login = (props) => {
  const { location } = props;
  const loggedIn = useSelector((state) => state.auth.loggedIn);
  const dispatch = useDispatch();

  if (loggedIn) return <Redirect to={get(location, "state.redirect", "/")} />;

  return (
    <div style={{ height: "calc(100vh - 45px)" }}>
      <div className="h-full flex justify-center items-center">
        <div className="w-full">
          <div className="w-1/2 border rounded mx-auto">
            <img
              style={{ marginTop: "-45px" }}
              className="mx-auto"
              src={logo}
              alt="Credex"
              width="141"
              height="40"
            />

            <h1 className="text-center text-20 mt-8 mb-8 font-normal">
              {t`Welcome back`} {t`in Credex Broker Agent`}!
            </h1>

            <div className="p-8 bg-white border-t">
              <Form
                onSubmit={(values) => dispatch(logIn(values))}
                render={({ handleSubmit }) => {
                  return (
                    <form onSubmit={handleSubmit}>
                      <div className="pb-5">
                        <Field
                          autoComplete="username"
                          name="username"
                          label={t`Username`}
                          component={Input}
                          validate={isRequired()}
                        />
                      </div>
                      <div className="pb-5">
                        <Field
                          autoComplete="current-password"
                          name="password"
                          label={t`Password`}
                          component={Input}
                          type="password"
                          validate={isRequired()}
                        />
                      </div>

                      <Button
                        title={t`Sign in`}
                        color="purple"
                        fullWidth
                        customProps={{
                          type: "submit",
                        }}
                      />
                    </form>
                  );
                }}
              />
            </div>
          </div>

          <div className="md:w-1/2 mx-auto text-right my-4">
            <Link
              className={`cursor-pointer hover-text-purple-menu no-underline leading-loose text-grey-darker-1`}
              to="forgot-password"
            >
              {t`Forgot password?`}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
